import { useMutation } from 'react-query'
import { type TaskUpdateStatusPersistence } from '../../../../types/persistence/task-update-status-persistence'
import { api } from '../../../api'

const updateTaskStatus = async (id: number, data: TaskUpdateStatusPersistence) => {
  const response = await api.put(`/tasks/${id}/status`, data)
  return response.data
}

export const useTaskUpdateStatusMutation = () => {
  return useMutation({
    mutationFn ({ id, data }: { id: number, data: TaskUpdateStatusPersistence }) {
      return updateTaskStatus(id, data)
    }
  })
}
